import { render, staticRenderFns } from "./InputMetricCategory.vue?vue&type=template&id=ca918f52"
import script from "./InputMetricCategory.vue?vue&type=script&lang=js"
export * from "./InputMetricCategory.vue?vue&type=script&lang=js"
import style0 from "./InputMetricCategory.vue?vue&type=style&index=0&id=ca918f52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports